import { analytics, storage } from "@/firebase";
import { logEvent } from "firebase/analytics";
import { FirebaseError } from "firebase/app";
import { uploadBytes, getDownloadURL, deleteObject, ref } from "firebase/storage";

/**
 * Helper function to upload an image to Firebase Storage
 */
export async function uploadImage(file: File, path: string): Promise<string> {
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
}

export async function deleteImage(path: string) {
  const imageRef = ref(storage, path);
  await deleteObject(imageRef);
}

export function logError(error: unknown, context?: string): void {
  // Determine error type
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorCode = error instanceof FirebaseError ? error.code : 'unknown';
  
  // Log to console (development)
  console.error(`[${context || 'App'}] Error:`, error);
  
  // Log to Firebase Analytics/Crashlytics (production)
  logEvent(analytics, 'app_error', {
    error_code: errorCode,
    error_message: errorMessage,
    context: context || 'unknown',
    timestamp: new Date().toISOString()
  });
}


